<script>
  // Form-field wrapper around the Combobox primitive (label + help + error plumbing).
  // Static lists via `options`; large server-backed lists via `source`
  // (an AdminSite::OptionsProp source key) + optional `sourceParams`.
  import Combobox from '../ui/combobox.svelte'

  let {
    value = $bindable(''),
    label,
    error,
    help,
    name,
    options = [],
    source = null,
    sourceParams = {},
    selected = null,
    placeholder = 'Select…',
    required = false,
    clearable = !required,
    disabled = false,
    onchange = null
  } = $props()
  // Unique per instance: a drawer's fields share names with the page form behind it.
  const uid = $props.id()
  const fieldId = `${name}-${uid}`
</script>

<fieldset class="fieldset">
  <legend class="fieldset-legend">{label}{#if required}<span class="text-error"> *</span>{/if}</legend>
  <Combobox
    bind:value
    id={fieldId}
    {options}
    {source}
    {sourceParams}
    {selected}
    {placeholder}
    {clearable}
    {disabled}
    {onchange}
    ariaLabel={label}
    error={!!error}
  />
  {#if help && !error}<p class="label whitespace-normal">{help}</p>{/if}
  {#if error}<p class="text-error text-sm mt-1">{Array.isArray(error) ? error[0] : error}</p>{/if}
</fieldset>
